import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=36c0b493&"
import script from "./TabGeneral.vue?vue&type=script&lang=js&"
export * from "./TabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports